import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BecomeOurPartnerForm from "./component";
import { setName, setMobile, setEmail } from "../../configuration/actions";
import {
    updateIsSubmitted,
    updatePincodeSelection,
    submitOnBoarding,
    updateDealerName
} from "./actions";

const mapStateToProps = ({
    user: {
        name,
        mobile,
        email
    },
    partnerForm: {
        isSubmitted,
        selectedPincode,
        dealerName
    }
}) => ({
    name,
    mobile,
    email,
    isSubmitted,
    selectedPincode,
    dealerName
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setNameConnect: setName,
    setMobileConnect: setMobile,
    setEmailConnect: setEmail,
    submitOnBoardingConnect: submitOnBoarding,
    updateIsSubmittedConnect: updateIsSubmitted,
    updatePincodeSelectionConnect: updatePincodeSelection,
    updateDealerNameConnect: updateDealerName
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BecomeOurPartnerForm);
